import { RockyInterface, Driver, Receiver } from './IntegratedInterface';
import { ddrDMTypes, LPDDR5, portSavePath } from '../constants';
import { PROJECT_V2 } from '../../../constants/projectVersion';
import { checkIfRDQSTSignal } from './dataProcess';
import { getPins } from './IbisModelHelper';

const TYPES = ['Controller', 'Memory'];
class RockyMergeSetup {

  mergeInterfacesInfo(interfaces, verificationName, projectType, projectVersion) {
    let newContent = new RockyInterface(verificationName);
    let interfacesInfo = JSON.parse(JSON.stringify(interfaces));
    if (interfacesInfo.length > 0) {
      if (projectVersion === PROJECT_V2 && verificationName.includes("CLK")) {
        let components = [], signals = [], powerNets = []
        for (let info of interfacesInfo) {
          const { Components, Signals, PowerNets = [] } = info.Content;
          const filterPowerNets = PowerNets.filter(item => !powerNets.find(it => it.name === item.name));
          if (filterPowerNets && filterPowerNets.length) {
            powerNets = [...powerNets, ...filterPowerNets];
          }

          const filterSignals = Signals.filter(item => !signals.find(it => it.name === item.name));
          if (filterSignals && filterSignals.length) {
            signals = [...signals, ...filterSignals];
          }

          for (let compInfo of Components) {
            const { name, pins, pkg } = compInfo;
            const findIndex = components.findIndex(item => item.name === name);
            if (findIndex > -1) {
              const filterPins = pins.filter(item => !components[findIndex].pins.find(it => it.pin === item.pin && it.net === item.net));
              if (filterPins && filterPins.length) {
                components[findIndex].pins.push(...filterPins)
              }
              // pkg
              if (pkg && pkg.type !== "None" && pkg.pairs && pkg.pairs.length) {
                // 
                const { files, pairs } = pkg;
                const currentCompPkgInfo = components[findIndex].pkg;
                const filterFiles = files.filter(item => !currentCompPkgInfo.files.find(it => it.subckt === item.subckt && it.fileName === item.fileName && it.libraryId === item.libraryId && it.modelKey === item.modelKey))
                if (filterFiles && filterFiles.length) {
                  components[findIndex].pkg.files.push(...filterFiles);
                }
                const filterPairs = pairs.filter(item => !currentCompPkgInfo.pairs.find(it => it.pin === item.pin));
                if (filterPairs && filterPairs.length) {
                  components[findIndex].pkg.pairs.push(...filterPairs);
                }
              }
            } else {
              components.push(compInfo);
            }
          }
        }
        newContent.Components = components;
        newContent.Signals = signals;
        newContent.PowerNets = powerNets;
      } else {
        let content = JSON.parse(JSON.stringify(interfacesInfo[0].Content))
        PRAMS.forEach(pram => content[pram] && newContent[pram].push(...content[pram]));
      }

    }
    interfacesInfo.forEach(info => {
      let { Content } = info;

      /* Merge component pins */
      /*  comp: {
         "deviceVcc": "1.5",
           "part": "XC7Z020-1CLG400I_XC7Z010-1CLG40",
             "name": "U8",
               "pins": [
                 {
                   "pin": "L2",
                   "corner": "typ",
                   "Driver": {
                     powerOff:"",
                     model:{},
                     pinModels:[]
                   },
                   "Receiver": {
                     model:{}
                   },
                   "net": "+DDR3_CK",
                   "signal": "CLKP"
                 }
               ]
       } */
      Content.Components.forEach(comp => {
        let index = newContent.Components.findIndex(item => item.name === comp.name);
        if (index > -1) {
          newContent.Components[index].pins.forEach(pin => {
            if (TYPES.includes(comp.type)) {
              let pinFind = comp.pins.find(item => item.pin === pin.pin);
              let Read = false, amiParams = {};
              //DM READ interface not display
              //find DM delete DM read usage
              if (pinFind) {
                let DMReg = new RegExp(`^(DM)`, 'ig');
                const words = pinFind.signal.match(DMReg);
                if ((words && ddrDMTypes.includes(projectType)) || (projectType === LPDDR5 && pinFind.signal.match(/(WCK)|(DQS)/g))) {
                  //DDR3/DDR3L/DDR4/DDR5/DDR4L  DM unidirectional
                  //LPDDR4 DM  Bidirectional
                  //LPDDR5 DQS unidirectional
                  let regRead = new RegExp(`(Read)`, 'ig');
                  const readFind = info.name.match(regRead);
                  if (readFind) {
                    Read = true;
                  }
                }
                amiParams = pinFind.model && (pinFind.model.libType === "IBIS_AMI" || pinFind.model.isAmi) ? {
                  amiModel: pinFind.amiModel,
                  amiModelUse: pinFind.amiModelUse,
                  amiODTValue: pinFind.amiODTValue,
                  amiModelInfo: pinFind.amiModelInfo || {},
                  amiParameters: pinFind.amiModelInfo && pinFind.amiModelInfo.amiParameters ? pinFind.amiModelInfo.amiParameters : [],
                  removeDcOffset: pinFind.removeDcOffset || false,
                } : {}
              }

              if (pinFind && pinFind.usage === 'Driver' && !Read) {
                pin.driver = new Driver({ powerOff: pinFind.powerOff, pinModels: pinFind.pinModels, model: pinFind.model, jitter: pinFind && pinFind.jitter ? pinFind.jitter : {}, dutyCycle: pinFind && pinFind.dutyCycle ? pinFind.dutyCycle : {}, amiParams, ads: pinFind.ads, adsStimulus: pinFind.adsStimulus });
                pin.stdDriverModel = pinFind.stdModel ? { ...pinFind.stdModel } : {};

              } else if (pinFind && pinFind.usage === 'Receiver' && !Read) {
                pin.receiver = new Receiver({ powerOff: pinFind.powerOff, pinModels: pinFind.pinModels, model: pinFind.model, amiParams, ads: pinFind.ads || {} });
                pin.stdReceiverModel = pinFind.stdModel ? { ...pinFind.stdModel } : {};
              }

              if (pinFind && pinFind.usage === 'Driver' && Read && checkIfRDQSTSignal(pin.signal)) {
                pin.driver = new Driver({ powerOff: pinFind.powerOff, pinModels: pinFind.pinModels, model: pinFind.model, jitter: pinFind && pinFind.jitter ? pinFind.jitter : {}, dutyCycle: pinFind && pinFind.dutyCycle ? pinFind.dutyCycle : {}, amiParams, ads: pinFind.ads, adsStimulus: pinFind.adsStimulus });
                pin.stdDriverModel = pinFind.stdModel ? { ...pinFind.stdModel } : {};
              } else if (pinFind && pinFind.usage === 'Receiver' && Read && checkIfRDQSTSignal(pin.signal)) {
                pin.receiver = new Receiver({ powerOff: pinFind.powerOff, pinModels: pinFind.pinModels, model: pinFind.model, amiParams, ads: pinFind.ads || {} });
                pin.stdReceiverModel = pinFind.stdModel ? { ...pinFind.stdModel } : {};
              }
              if (pinFind && pinFind.stdModel) {
                pin.stdModel = { ...pinFind.stdModel };
              }
              if (pinFind && pinFind.dimmStdModels) {
                pin.dimmStdModels = JSON.parse(JSON.stringify(pinFind.dimmStdModels));
              }
              if (pinFind && pinFind.model && (pinFind.model.libType === "IBIS_AMI" || pinFind.model.isAmi) && pinFind.amiModelInfo && pinFind.amiModelInfo.amiParameters && pinFind.amiModelInfo.amiParameters.length) {
                const pinParams = pin.amiModelInfo ? pin.amiModelInfo.amiParameters || [] : []
                const pinFindParams = pinFind.amiModelInfo.amiParameters || [];
                const pinIgnoreBits = pinParams.find(p => p.name === 'Ignore_Bits');
                const pinFindIgnoreBits = pinFindParams.find(p => p.name === 'Ignore_Bits');
                if (!pinIgnoreBits && pinFindIgnoreBits) {
                  pin.amiModelInfo = JSON.parse(JSON.stringify(pinFind.amiModelInfo));
                } else if (pinIgnoreBits && pinFindIgnoreBits) {
                  const pinValue = pinIgnoreBits.value !== undefined ? pinIgnoreBits.value : pinIgnoreBits.defaultValue;
                  const pinFindValue = pinFindIgnoreBits.value !== undefined ? pinFindIgnoreBits.value : pinFindIgnoreBits.defaultValue;
                  if (pinValue < pinFindValue) {
                    pin.amiModelInfo = JSON.parse(JSON.stringify(pinFind.amiModelInfo));
                  } else {
                    pin.amiModelInfo = JSON.parse(JSON.stringify(pin.amiModelInfo));
                  }
                }
              }

              delete pin.pinModels;
              delete pin.model;
              delete pin.usage;
              delete pin.powerOff;
            }
          })
        }
      })
    });
    //add channel and extraction
    //newContent.Channel = interfacesInfo && interfacesInfo[0] && interfacesInfo[0].Content.Channel || new Channel();
    //newContent.Extraction = interfacesInfo && interfacesInfo[0] && interfacesInfo[0].Content.Extraction || new Extraction();

    newContent.VTTNets = interfacesInfo && interfacesInfo[0] && interfacesInfo[0].Content.VTTNets ? JSON.parse(JSON.stringify(interfacesInfo[0].Content.VTTNets)) : [];
    //find ports by interface
    const portsInterface = interfacesInfo.find(i => portSavePath.find(p => i.name.match(p))).Content || {};
    newContent.Ports_generate_setup_list = portsInterface && portsInterface.Ports_generate_setup_list ? JSON.parse(JSON.stringify(portsInterface.Ports_generate_setup_list)) : [];
    newContent.ReferenceNets = portsInterface && portsInterface.ReferenceNets ? JSON.parse(JSON.stringify(portsInterface.ReferenceNets)) : [];
    newContent.Port_setups = portsInterface && portsInterface.Port_setups ? JSON.parse(JSON.stringify(portsInterface.Port_setups)) : [];
    newContent.VirtualComps = portsInterface && portsInterface.VirtualComps ? JSON.parse(JSON.stringify(portsInterface.VirtualComps)) : [];
    newContent.PowerComponents = portsInterface && portsInterface.PowerComponents ? JSON.parse(JSON.stringify(portsInterface.PowerComponents)) : [];
    this.initRDQSTDriver(newContent);

    return newContent;
  }

  initRDQSTDriver(newContent) {
    newContent.Components.forEach(comp => {
      comp.pins.forEach(pin => {
        if (checkIfRDQSTSignal(pin.signal)) {
          const keys = Object.keys(pin);
          if (!keys.includes("driver")) {
            pin.driver = new Driver({ poweroff: "0", pinModels: getPins({ usage: "Driver" }), model: {} });
          }
          if (!keys.includes("receiver")) {
            pin.receiver = new Receiver({ poweroff: "0", pinModels: getPins({ usage: "Receiver" }), model: {} });
          }
        }
      })
    })
  }

  mergeCLKInterfacesInfo(interfaces, verificationName, projectType, projectVersion) {
    let newContent = new RockyInterface(verificationName);
    let interfacesInfo = JSON.parse(JSON.stringify(interfaces));
    if (interfacesInfo.length > 0) {
      let components = [], signals = [], powerNets = []
      for (let info of interfacesInfo) {
        const { Components, Signals, PowerNets } = info.Content;
        const filterPowerNets = PowerNets.filter(item => !powerNets.find(it => it.name === item.name));
        if (filterPowerNets && filterPowerNets.length) {
          powerNets = [...powerNets, ...filterPowerNets];
        }

        const filterSignals = Signals.filter(item => !signals.find(it => it.name === item.name));
        if (filterSignals && filterSignals.length) {
          signals = [...signals, ...filterSignals];
        }

        for (let compInfo of Components) {
          const { name, pins } = compInfo;
          const findIndex = components.findIndex(item => item.name === name);
          if (findIndex > -1) {
            const filterPins = pins.filter(item => !components[findIndex].pins.find(it => it.pin === item.pin && it.net === item.net));
            if (filterPins && filterPins.length) {
              components[findIndex].pins.push(...filterPins)
            }
          } else {
            components.push(compInfo);
          }
        }
      }
      newContent.Components = components;
      newContent.Signals = signals;
      newContent.PowerNets = powerNets;
    }

    interfacesInfo.forEach(info => {
      let { Content } = info;

      Content.Components.forEach(comp => {
        let index = newContent.Components.findIndex(item => item.name === comp.name);
        if (index > -1) {
          newContent.Components[index].pins.forEach(pin => {
            if (TYPES.includes(comp.type)) {
              let pinFind = comp.pins.find(item => item.pin === pin.pin);
              let Read = false;
              //DM READ interface not display
              //find DM delete DM read usage
              if (pinFind) {
                let DMReg = new RegExp(`^(DM)`, 'ig');
                const words = pinFind.signal.match(DMReg);
                if ((words && ddrDMTypes.includes(projectType)) || (projectType === LPDDR5 && pinFind.signal.match(/(WCK)|(DQS)/g))) {
                  //DDR3/DDR3L/DDR4/DDR5/DDR4L  DM unidirectional
                  //LPDDR4 DM  Bidirectional
                  //LPDDR5 DQS unidirectional
                  let regRead = new RegExp(`(Read)`, 'ig');
                  const readFind = info.name.match(regRead);
                  if (readFind) {
                    Read = true;
                  }
                }
              }

              if (pinFind && pinFind.usage === 'Driver' && !Read) {
                pin.driver = new Driver({ powerOff: pinFind.powerOff, pinModels: pinFind.pinModels, model: pinFind.model })
              } else if (pinFind && pinFind.usage === 'Receiver' && !Read) {
                pin.receiver = new Receiver({ powerOff: pinFind.powerOff, pinModels: pinFind.pinModels, model: pinFind.model });
              }
              if (pinFind && pinFind.stdModel) {
                pin.stdModel = { ...pinFind.stdModel };
              }
              if (pinFind && pinFind.dimmStdModels) {
                pin.dimmStdModels = JSON.parse(JSON.stringify(pinFind.dimmStdModels));
              }

              delete pin.pinModels;
              delete pin.model;
              delete pin.usage;
              delete pin.powerOff;
            }
          })
        }
      })
    });
    //add channel and extraction
    newContent.VTTNets = interfacesInfo && interfacesInfo[0] && interfacesInfo[0].Content.VTTNets ? JSON.parse(JSON.stringify(interfacesInfo[0].Content.VTTNets)) : [];
    //find ports by interface
    const portsInterface = interfacesInfo.find(i => portSavePath.find(p => i.name.match(p))).Content || {};
    newContent.Ports_generate_setup_list = portsInterface && portsInterface.Ports_generate_setup_list ? JSON.parse(JSON.stringify(portsInterface.Ports_generate_setup_list)) : [];
    newContent.ReferenceNets = portsInterface && portsInterface.ReferenceNets ? JSON.parse(JSON.stringify(portsInterface.ReferenceNets)) : [];
    newContent.Port_setups = portsInterface && portsInterface.Port_setups ? JSON.parse(JSON.stringify(portsInterface.Port_setups)) : [];
    newContent.VirtualComps = portsInterface && portsInterface.VirtualComps ? JSON.parse(JSON.stringify(portsInterface.VirtualComps)) : [];

    return newContent;
  }

}

const PRAMS = ['Signals', 'Components', 'PowerNets'];


const RockySetup = new RockyMergeSetup();
export default RockySetup;